import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=087b4bd3&scoped=true&"
import script from "./QuestionHeader.vue?vue&type=script&lang=ts&"
export * from "./QuestionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionHeader.vue?vue&type=style&index=0&id=087b4bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b4bd3",
  null
  
)

export default component.exports